import React from 'react';
import styles from './Sizes.module.scss';
import { sortSizes } from '../utils/sizes';

export const Size = ({ size }) => <div className={styles.size}>{size}</div>;

export const Sizes = ({ sizes }) => {
  if (!sizes) return null;
  const orderedSize = sortSizes(sizes);
  return (
    <div className={styles.sizes}>
      {orderedSize
        ? orderedSize.map((size) => <Size key={size} size={size} />)
        : null}
    </div>
  );
};
